import "vite/modulepreload-polyfill";
import "./main.css";

import * as Sentry from "@sentry/vue";

import { createSSRApp, DefineComponent, h } from "vue";
import { createInertiaApp, router } from "@inertiajs/vue3";
import { i18nPlugin } from "@/i18n/plugin";
import axios from "axios";
import { toast } from "vue-sonner";

import en from "./i18n/en/djangojs.json";

const pages = import.meta.glob<DefineComponent>("./pages/**/*.vue");

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

createInertiaApp({
    resolve: async (name) => {
        const componentPath = `./pages/${name}.vue`;
        if (!(componentPath in pages)) {
            throw new Error(`Page not found: '${name}'`);
        }
        return pages[componentPath]();
    },
    setup({ el, App, props, plugin }) {
        const vueApp = createSSRApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18nPlugin, {
                localeFiles: { en },
            });
        if (props.initialPage.props.envSentryDsn) {
            Sentry.init({
                app: vueApp,
                dsn: props.initialPage.props.envSentryDsn as string,
                sendDefaultPii: true,
                enableLogs: true,
                integrations: [Sentry.browserTracingIntegration()],
                environment: props.initialPage.props.envEnvironment as string,
                release: props.initialPage.props.envReleaseReference as string,
            });
        }
        vueApp.mount(el);
    },
    progress: {
        color: "#5fcced",
    },
});

router.on("exception", (event) => {
    toast.error(
        event.detail.exception.message || "An unexpected error occurred",
    );
});
